<template>
  <div>
      
        <div class="dress-card">
          <div class="dress-card-head">
            <a v-link="($route.params.id != 20 && product.Available)? { name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }} : '' ">
              <img class="dress-card-img-top" v-lazy="product.Photos[0].URL" alt="">
            </a>
            <div class="dress-card-body">
              <a v-link="($route.params.id != 20 && product.Available)? { name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }} : '' ">
              <h4 class="dress-card-title">{{product.Name}}</h4>
              </a>
            
            <div class="action-wrap">
                  <span v-if="product.Available" class="text-success">Beschikbaar</span>
                  <span v-else class="text-danger">Verkocht</span>
                  <div class="price-wrap h3">
                    <span class="price-new" v-if="product.Available && !product.PriceOnRequest" >{{product.Price | currencyDisplay}}</span>
                    <span class="price-new" v-if="product.Available && product.PriceOnRequest" >Prijs Op Aanvraag</span>
                    <span class="price-new" v-else >&nbsp;</span>
                  </div>
              </div>
              <div class="row" >
                <div class="col-md-9 card-button" :class="!product.Available ? 'isDisabled' : ''"><a v-link="$route.params.id != 20 ? { name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }} : '' "><div class="card-button-inner bag-button">Bekijk en bestel</div></a></div>
                <div class="col-md-3 card-button" :class="!product.Available ? 'isDisabled' : ''"><a v-on:click.prevent="addToShoppingCart()" href="#"><div class="card-button-inner wish-button">+<span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span></div></a></div>
              </div>
            </div>
          </div>
        </a>
  </div>
</template>

<script>
import store from '../../store'

export default {
  route: {
    canReuse: false
  },
  props: {
    product: Object
  },
  data () {
    return {
      store: store,
      loaded: false
    }
  },
  methods: {
    addToShoppingCart: function () {
      if (!this.containsProduct(this.product, this.store.cart)) {
        this.store.cart.push(this.product)
        sessionStorage.setItem('winkelwagen', JSON.stringify(this.store.cart))
      }
    },
    containsProduct: function (obj, list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].ProductId === obj.ProductId) {
          return true
        }
      }
      return false
    }
  },
  created () {
  }
}
</script>

<style scoped>
  @media screen and (max-width: 768px){
    p{
      font-size: 3.2vw;
    }
    .dress-card-img-top {
      width: 100%;
      height: 100%;
      border-radius: 7px 7px 0 0;
    }
    body {
    background-color: black;
  }
  }

.isDisabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.isDisabled > a {
  pointer-events: none;
  text-decoration: none;
}
/* card */
.dress-card-img-top {
  width: 100%;
  height: 33.3vh;
  border-radius: 7px 7px 0 0;
}

.dress-card-body {
  padding:1rem;
  background: #fff;
  border-radius: 0 0 7px 7px;
  margin-bottom: 7px;
}

.dress-card-title {
  overflow: hidden;
  white-space: nowrap;
  height: 2.2em;
  color: black;
}

.dress-card-crossed {
  text-decoration: line-through;
}

.dress-card-price {
  font-size: 1rem;
  font-weight: bold;
}

.dress-card-off {
  color: #ad1457;
}

.dress-card-para {
  margin-bottom: 0.2rem;
  font-size: 1.0rem;
  margin-bottom: 0rem;
}

.dress-card {
  border-radius: 14px;
}

.dress-card-heart {
  font-size: 1em;
  color: #DB2763;
  margin: 4.5px;
  position: absolute;
  left: 4px;
  top: 0px;
  
}

.card-button {
  text-align: center;
  font-size: 15px;
  padding: 9px;
  vertical-align:bottom
}

.card-button a {
  text-decoration: none;
}

.card-button-inner {
  padding: 10px;
  border-radius: 3px;
}

.bag-button {
  background: #aaaaaa;
  color: white;
}

.wish-button {
  border: 1px solid #ad1457;
  color: #ad1457;
}


</style>


// WEBPACK FOOTER //
// ProductCard.vue?60332044